import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export const maturityFormatter = (
	months: number,
	t: (key: string, options: { count: number }) => string,
) => {
	const years = Math.floor(months / 12);
	const remainingMonths = months % 12;
	const parts: string[] = [];

	if (years > 0) {
		parts.push(
			t(Resources.PortfolioDetail.Loan.Frequency.Years, { count: years }),
		);
	}

	if (remainingMonths > 0) {
		parts.push(
			t(Resources.PortfolioDetail.Loan.Frequency.Months, {
				count: remainingMonths,
			}),
		);
	}

	return parts.join(" ");
};
